export const convertDollarStringToNumber = (value: string): number => {
	const strippedValue: any = value.replace(/\$|,/g, "");
	if (strippedValue && !isNaN(strippedValue)) {
		return parseFloat(strippedValue);
	}
};